import { memo } from 'react';

import { AppletUnit } from './AppletUnit';
import { CollapsibleUnit } from './CollapsibleUnit';
import { IframeUnit } from './IframeUnit';
import { ImageUnit } from './ImageUnit';
import { InlineVideoUnit } from './InlineVideoUnit';
import { TableUnit } from './TableUnit';
import { TextUnit, type HeadingLevel } from './TextUnit';
import type { NormalizedContentUnit } from './useComponent';

interface ContentUnitProps {
  disableCollapseWrapper?: boolean;
  headingLevel?: HeadingLevel;
  hideHeading?: boolean;
  unit: NormalizedContentUnit;
}

export const ContentUnit = memo(function ContentUnit({
  disableCollapseWrapper = false,
  headingLevel = 2,
  hideHeading = false,
  unit,
}: ContentUnitProps) {
  const renderer =
    unit.kind === 'text' ? (
      <TextUnit headingLevel={headingLevel} hideHeading={hideHeading} unit={unit} />
    ) : unit.kind === 'image' ? (
      <ImageUnit headingLevel={headingLevel} hideHeading={hideHeading} unit={unit} />
    ) : unit.kind === 'applet' ? (
      <AppletUnit headingLevel={headingLevel} hideHeading={hideHeading} unit={unit} />
    ) : unit.kind === 'iframe' ? (
      <IframeUnit headingLevel={headingLevel} hideHeading={hideHeading} unit={unit} />
    ) : unit.kind === 'table' ? (
      <TableUnit headingLevel={headingLevel} hideHeading={hideHeading} unit={unit} />
    ) : (
      <InlineVideoUnit headingLevel={headingLevel} hideHeading={hideHeading} unit={unit} />
    );

  if (disableCollapseWrapper || !unit.collapseByDefault) {
    return renderer;
  }

  const collapsedRenderer =
    unit.kind === 'text' ? (
      <TextUnit headingLevel={headingLevel} hideHeading unit={unit} />
    ) : unit.kind === 'image' ? (
      <ImageUnit headingLevel={headingLevel} hideHeading unit={unit} />
    ) : unit.kind === 'applet' ? (
      <AppletUnit headingLevel={headingLevel} hideHeading unit={unit} />
    ) : unit.kind === 'iframe' ? (
      <IframeUnit headingLevel={headingLevel} hideHeading unit={unit} />
    ) : unit.kind === 'table' ? (
      <TableUnit headingLevel={headingLevel} hideHeading unit={unit} />
    ) : (
      <InlineVideoUnit headingLevel={headingLevel} hideHeading unit={unit} />
    );

  return (
    <CollapsibleUnit summaryLabel={unit.summaryLabel}>
      {collapsedRenderer}
    </CollapsibleUnit>
  );
});
